import React, { Component } from 'react';
import Item from './Item';
import _ from 'lodash';
import cx from 'classnames';
import Icon from 'react-fa';

class ItemList extends Component {
    constructor(props) {
        super(props);

        this.state = this.generateInitialState(this.props.items);
        this.renderItems = this.renderItems.bind(this);
        this.onStarChange = this.onStarChange.bind(this);
        this.onButtonClick = this.onButtonClick.bind(this);
        this.sendEnabled = this.sendEnabled.bind(this);
        this.renderSpinner = this.renderSpinner.bind(this);
    }

    onStarChange(itemId, starCount) {
        if (!this.props.submitting) {
            this.setState({
                [itemId.toString()]: starCount
            });
        }
    }


    onButtonClick(_event) {
        this.props.onSubmit(this.state);
    }

    generateInitialState(items) {
        const state = {};
        _.forEach(items, (item) => {
            state[item.id] = 0;
        });
        return state;
    }

    sendEnabled() {
        return _.reduce(this.props.items, (acc, item) => (
			this.state[item.id] * acc
		), 1) > 0 && !this.props.submitting;
    }

    renderSpinner() {
        if (this.props.submitting) {
            return (
                <Icon
                    name="spinner"
                    className="fa-spin"
                />
			);
        } else {
            return null;
        }
    }

    renderItems() {
        return this.props.items.map((item) => (
            <Item
                key={item.id}
                id={item.id}
                title={item.title}
                onChange={this.onStarChange}
                stars={this.state[item.id.toString()]}
                description={item.description}
                brand={this.props.brand}
            />));
    }

    render() {
        const buttonClasses = cx({
            answers: true,
            protherm: this.props.brand === 'protherm',
            vaillant: this.props.brand === 'vaillant'
        });

        return (
            <div className="content">
				{this.renderItems()}
                <button
                    className={buttonClasses}
                    disabled={!this.sendEnabled()}
                    onClick={this.onButtonClick}
                >
					Odoslať hodnotenie
					{this.renderSpinner()}
                </button>
            </div>
		);
    }
}

ItemList.propTypes = {
    items: React.PropTypes.array.isRequired,
    onSubmit: React.PropTypes.func.isRequired,
    brand: React.PropTypes.string.isRequired,
    submitting: React.PropTypes.bool.isRequired
};
ItemList.defaultProps = {};
ItemList.contextTypes = {};

export default ItemList;



/** WEBPACK FOOTER **
 ** ./src/components/ItemList.js
 **/